import {getCookie} from "../utils/utils";

export default class Modal {
    constructor(modal) {
        this.modalClosers   = document.querySelectorAll('[data-action="modal-close"]');
        this.flashModal     = document.querySelector('.modal--flash');

        this.modalClosers && this.modalClosers.forEach((modalCloser) => {
            modalCloser.addEventListener('click', () => {
                this.closeModal(modalCloser);
            });
        });

        this.checkCookieExpiration('mainBanner');
        this.checkCookieExpiration('flashBanner');

        // if(this.flashModal) {
        //     this.flashEllipsis(this.flashModal);
        // }

		// SET IMAGE MODAL WIDTH TO BE SQUARE
		modal.forEach((modal) => {
			if(modal.classList.contains('modal--image')) {
				let wrap = modal.querySelector('.modal__text-wrap');
				let image = modal.querySelector('.modal__image');
				image.style.setProperty('--width', wrap.offsetHeight + 'px')
			}
		});
		
    }

    closeModal(modal) {
        if(modal.dataset.modal !== 'formSuccess') {
            let now = new Date();
            let time = now.getTime();
            let expireTime = time + 1000 * 36000;
            now.setTime(expireTime);
            document.cookie = modal.dataset.modal + "=" + now.toUTCString() + "; expires=" + now.toUTCString() + "; path=/";

            modal.closest('[data-component="modal"]').classList.remove('modal--visible');

            if (modal.dataset.modal === 'flashBanner') {
                document.body.classList.remove('modal--visible');
            }
        } else {
            modal.closest('[data-component="modal"]').classList.remove('modal--visible');
        }
    }

    checkCookieExpiration(cookieName) {
        if(getCookie(cookieName)) {
            let expirationDate = getCookie(cookieName);

            let now = new Date();
            let time = now.getTime();
            now.setTime(time);

            // If cookie has expired, re-prompt user
			let setDate = new Date(now.toUTCString());
			let expireDate = new Date(expirationDate);
            if(setDate.getTime() > expireDate.getTime()) {
                // Delete cookie if expired
                document.cookie = cookieName+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
        }
    }

    flashEllipsis(modal) {
        setInterval(() => {
            this.modal              = modal;
            this.modalContent       = modal.querySelector('.modal__content');
            this.modalTextContainer = modal.querySelector('p, a');
            this.modalText          = modal.querySelector('span').getBoundingClientRect();
            //console.log(this.modalText.right);
            console.log(this.modalText.right + this.modalTextContainer.offsetWidth);
            console.log(this.modalText.right);
            if(this.modalText.right + this.modalTextContainer > 200) {
                this.modalContent.classList.add('modal__content--ellipsis-right');
            } else {
                this.modalContent.classList.remove('modal__content--ellipsis-right');
            }
        }, 100);
    }
}